var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecureChatInviteGreyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16.999,
    viewBox: "0 0 17 16.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161578",
    "data-name": "Group 161578",
    transform: "translate(9245 21065.92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161570",
    "data-name": "Group 161570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161546",
    "data-name": "Group 161546",
    transform: "translate(-9245 -21065.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "protect-svgrepo-com",
    d: "M2.005,6.344l.487,4.379a7.65,7.65,0,0,0,3.549,5.643l4.009,2.506a.85.85,0,0,0,.9,0l4.009-2.506a7.65,7.65,0,0,0,3.549-5.643L19,6.344a.85.85,0,0,0-.5-.871l-7.65-3.4a.85.85,0,0,0-.69,0L2.5,5.473A.85.85,0,0,0,2.005,6.344Zm1.758.43L10.5,3.781l6.737,2.993-.418,3.761a5.95,5.95,0,0,1-2.76,4.389L10.5,17.148,6.942,14.924a5.95,5.95,0,0,1-2.76-4.389Z",
    transform: "translate(-2 -2.001)",
    fill: "#a0a0a0",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "tick-svgrepo-com",
    d: "M4.892,10.184l1.771,1.771L10.618,8",
    transform: "translate(-9243.834 -21067.998)",
    fill: "none",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureChatInviteGreyIcon);
export default __webpack_public_path__ + "static/media/secure-chat-invite-grey-icon.c153593a8fdbd3a8273ece344365d9ee.svg";
export { ForwardRef as ReactComponent };